import { useEffect } from "react";
import { Controller } from "react-hook-form";
import { useWatch } from "react-hook-form";
import classNames from "classnames";

import { CCol, CRow } from "@coreui/react";

import { useMobileDevice } from "src/utils/hooks/viewport";

import { CDate, CSelect, CTextarea } from "_components/controls";

import { getAll as getAllMaterialGroup } from "../../../queries-fn/material-group.query";
import { getByStore as getUserByStore } from "../../../queries-fn/user.query";
import { getAll as getAllWarehouse } from "../../../queries-fn/warehouse.query";

export const Info = ({
  control,
  isEdit,
  setValue,
  handleSelectMaterialGroup,
}) => {
  //#region Data
  const store_code = useWatch({ control, name: "store_code" });

  const { data: materialGroups } = getAllMaterialGroup({}, false);

  const { data: warehouses } = getAllWarehouse({}, false);

  const { data: users } = getUserByStore(store_code, !store_code);

  const isMobile = useMobileDevice();
  //#endregion

  //#region Event
  const onSelectWarehouse = ({ data, value }) => {
    setValue("store_code", data.store_code);
    setValue("ware_code", data.code);
  };
  //#endregion

  useEffect(() => {
    if (!isEdit && users && users?.length > 0) {
      setValue("created_by", users[0]?.value);
    }
  }, [isEdit, users]);

  //#region Render
  return (
    <CRow className={classNames(isMobile ? "mt-0" : "mt-3")}>
      <CCol xs="12" sm="6" md="4" lg="4" xl="4" xxl="4">
        <Controller
          name="created_by"
          control={control}
          render={({ field }) => (
            <CSelect
              options={users}
              label="Người kiểm"
              required
              select="value"
              {...field}
            />
          )}
        />
      </CCol>
      <CCol xs="12" sm="6" md="4" lg="4" xl="4" xxl="4">
        <Controller
          name="checked"
          control={control}
          render={({ field }) => (
            <CDate maxDate={Date.now()} label="Ngày kiểm" required {...field} />
          )}
        />
      </CCol>
      <CCol xs="12" sm="6" md="4" lg="4" xl="4" xxl="4">
        <Controller
          name="ware_code"
          control={control}
          render={({ field }) => (
            <CSelect
              options={warehouses}
              label="Kho kiểm"
              required
              {...field}
              onChange={onSelectWarehouse}
            />
          )}
        />
      </CCol>
      <CCol xs="12" sm="6" md="4" lg="4" xl="4" xxl="4">
        <Controller
          name="group_code"
          control={control}
          render={({ field: { onChange, ..._field } }) => {
            return (
              <CSelect
                label="Nhóm Nguyên Vật Liệu"
                options={materialGroups}
                {..._field}
                required
                select="value"
                onChange={handleSelectMaterialGroup(onChange)}
              />
            );
          }}
        />
      </CCol>
      <CCol xs="12" sm="12" md="8" lg="8" xl="8" xxl="8">
        <Controller
          name="note"
          control={control}
          render={({ field }) => (
            <CTextarea label="Ghi chú" placeholder="Nhập ghi chú" {...field} />
          )}
        />
      </CCol>
    </CRow>
  );
  //#endregion
};
